// transaction key storage
export const TRANSACTION_PENDING_SELLER_CONFIRMATION = 'pending-seller-confirmation';
export const TRANSACTION_PENDING_ATTACHMENTS = 'pending-attachments';

// intro storage keys
export const HOMEPAGE_IS_FIRST_VISIT_KEY = 'intro-hpifv';
export const VOUCHER_SINGLE_PAGE_IS_FIRST_VISIT_KEY = 'intro-vspifs';
export const PROFILE_PAGE_IS_FIRST_VISIT_KEY = 'intro-ppifv';
